// material-ui
import { useTheme } from "@mui/material/styles";
import { Avatar, Box, useMediaQuery } from "@mui/material";

// project imports
import LAYOUT_CONST from "constant";
import useConfig from "hooks/useConfig";
import LogoSection from "../LogoSection";
import SearchSection from "./SearchSection";
import MobileSection from "./MobileSection";
import ProfileSection from "./ProfileSection";
import NotificationSection from "./NotificationSection";

import { useDispatch, useSelector } from "store";
import { openDrawer } from "store/slices/menu";

// assets
import { IconMenu2 } from "@tabler/icons";
import useRequestIdGenerater from "customhooks";
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp";
import axios from "axios";
import { useEffect, useState } from "react";
import UploadProfilePicture from "views/alumniRegistration/alumniProfile/UploadProfilePicture";

const Header = () => {
  const theme = useTheme();

  const dispatch = useDispatch();
  const { drawerOpen } = useSelector((state) => state.menu);
  const ROLE = localStorage.getItem("role");
  const isRole = ROLE === "ROLE_ALUMNI";

  const matchDownMd = useMediaQuery(theme.breakpoints.down("md"));
  const { layout } = useConfig();

  const RequestId = useRequestIdGenerater();
  const { rendomRequestId, generateTimeStamp } = useTimeStamp();

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [responseData, setResponseData] = useState([]);

  const getAlumniDetails = async () => {
    try {
      const response = await axios.get(
        `/v1/alumni/info?userId=${localStorage.getItem("userId")}`,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem(
              "serviceToken"
            )}`,
            "Content-Type": "application/json",
            requestId: RequestId(
              Math.floor(1000 + Math.random() * 9999 + rendomRequestId),
              Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
            ),
          },
        }
      );
      const avatar = response?.data?.data?.avatar;
      setResponseData(response?.data?.data);
      if (
        !response?.data?.data?.feePaid &&
        response?.data?.data?.alumniStatus !== "Pending"
      ) {
        if (!avatar) {
          setIsDialogOpen(true);
        } else {
          setIsDialogOpen(false);
        }
      }
      generateTimeStamp();
    } catch (error) {
      generateTimeStamp();
      console.error("Failed to fetch data:", error);
    }
  };

  useEffect(() => {
    if (isRole) {
      getAlumniDetails();
    }
  }, []);

  return (
    <>
      <Box
        sx={{
          width: 228,
          display: "flex",
          height: 50,
          [theme.breakpoints.down("md")]: {
            width: "auto",
          },
        }}
      >
        <Box
          component="span"
          sx={{ display: { xs: "none", md: "block", padding: 0 }, flexGrow: 1 }}
        >
          <LogoSection drawerOpen={drawerOpen} />
        </Box>

        {!isRole ? (
          <>
            {layout === LAYOUT_CONST.VERTICAL_LAYOUT ||
            (layout === LAYOUT_CONST.HORIZONTAL_LAYOUT && matchDownMd) ? (
              <Avatar
                variant="rounded"
                sx={{
                  ...theme.typography.commonAvatar,
                  ...theme.typography.mediumAvatar,
                  overflow: "hidden",
                  transition: "all .2s ease-in-out",
                  background:
                    theme.palette.mode === "dark"
                      ? theme.palette.dark.main
                      : theme.palette.secondary.light,
                  color:
                    theme.palette.mode === "dark"
                      ? theme.palette.secondary.main
                      : theme.palette.secondary.dark,
                  "&:hover": {
                    background:
                      theme.palette.mode === "dark"
                        ? theme.palette.secondary.main
                        : theme.palette.secondary.dark,
                    color:
                      theme.palette.mode === "dark"
                        ? theme.palette.secondary.light
                        : theme.palette.secondary.light,
                  },
                }}
                onClick={() => dispatch(openDrawer(!drawerOpen))}
                color="inherit"
              >
                <IconMenu2 stroke={1.5} size="20px" />
              </Avatar>
            ) : null}
          </>
        ) : (
          ""
        )}
      </Box>
      {/* header search */}
      <SearchSection />
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />
      {/* mega-menu */}
      <Box sx={{ display: { xs: "none", sm: "block" } }}>
        {/* <MegaMenuSection /> */}
      </Box>
      {/* live customization & localization */}
      {/* <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                <LocalizationSection />
            </Box> */}
      {/* notification & profile */}

      {isRole && <NotificationSection />}
      {/* <DarkLightMode /> */}
      <ProfileSection responseData={responseData} />
      {/* mobile header */}
      <Box sx={{ display: { xs: "block", sm: "none" } }}>
        <MobileSection />
      </Box>
      <UploadProfilePicture
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        getAlumniDetails={getAlumniDetails}
      />
    </>
  );
};

export default Header;
